<template>
  <md-list-item @click="redirect(menu)" :key="idx" :md-expand="Boolean(menu.items && menu.items.length > 0)" :md-expanded.sync="expanded">
    <md-icon>{{ menu.icon }}</md-icon>
    <span class="md-list-item-text" :class="{'s1-U__text-color--primary' : expanded }">{{ $t(menu.name) }}</span>
    <md-tooltip md-direction="right" v-show="!visible">{{ $t(menu.tooltip) }}</md-tooltip>
    <md-list slot="md-expand" v-if="menu.items && menu.items.length > 0">
      <md-list-item v-for="item in menu.items" @click="redirect(item)" :key="item.name">
        <md-icon>{{ item.icon }}</md-icon>
        <span class="md-list-item-text">{{ $t(item.name) }}</span>
        <md-tooltip md-direction="right" v-show="!visible">{{ $t(item.tooltip) }}</md-tooltip>
      </md-list-item>
    </md-list>
  </md-list-item>
</template>
<script>
export default {
  data: () => ({
    expanded: false
  }),
  props: {
    menu: Object,
    visible: Boolean
  },
  methods: {
    redirect(item) {
      if (item && item.route && !item.items) {
        let preRoute = this.$store.state.i18n && this.$store.state.i18n.locale;
        if (preRoute && preRoute !== '') {
          preRoute = '/' + preRoute;
        }
        this.$router.push(`${preRoute}${item.route}`);
      }
    }
  }
}
</script>
